import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the FiltersHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'filters-header',
  templateUrl: 'filters-header.html',
  styleUrls: ['./filters-header.scss'],
  standalone: false
})
export class FiltersHeaderComponent {

  filterHeader: string;

  constructor(private translateService: TranslateService) {
    console.log('Hello FiltersHeaderComponent Component');
    this.filterHeader = this.translateService.instant('SORTANDFILTER.SELECT_FILTERS');
  }

}
